<template>
  <v-text-field
    :clearable="canClear"
    v-model="data"
    :outlined="setOutline"
    :filled="setFill"
    :background-color="setBg"
    :disabled="setDisable"
    :dense="setDense"
    :counter="setCounter"
    :hint="setHint"
    :persistent-hint="setPersistentHint"
    @input="handleInput"
  >
    <template #prepend v-if="prelabelDisplay">{{ pre_label }}: </template>
    <template #append-outer v-if="postlabelDisplay">
      {{ post_label }}
    </template>
    <template #label v-if="fieldLabel">
      {{ full_label }}
    </template>
  </v-text-field>
</template>
<script setup>
  import check from "@/../../library/helper/propertyCheck.js";
  import { computed, ref, onMounted } from "vue";

  // Define the properties
  const props = defineProps({
    config: { type: Object, required: false },
    label: {
      type: String,
      required: false,
    },
    postlabel: {
      type: String,
      required: false,
    },
    prelabel: {
      type: String,
      required: false,
    },
    value: {type: [String, Number], require: true}
  });

  // Define emits
  const emit = defineEmits(["input"]);

  // Define the data field for the field contents
  let data = ref("");

  // Load the initial value into data
  onMounted(() => {
    data.value = props?.value
  })
  // Handle the user text input
  const handleInput = () => {
    emit("input", data.value);
  };

  // Property check method
  const propCheck = (key, value) =>
    check.checkSetting(props.config, key, value);

  // Visual Settings
  const setOutline = computed(() => propCheck("outline", false));
  const setFill = computed(() => propCheck("filled", false));
  const setBg = computed(() => propCheck("bgColog", undefined));
  const setDisable = computed(() => propCheck("disabled", false));
  const setDense = computed(() => propCheck("dense", false));
  const setCounter = computed(() => propCheck("counter", undefined));
  const setHint = computed(() => propCheck("hint", undefined))
  const setPersistentHint = computed(() => propCheck("persistent_hint", false))

  // Label Settings
  const full_label = computed(() => {
    if (!check.isUndefined(props.label)) return props.label;
    return "";
  });
  const pre_label = computed(() => {
    if (!check.isUndefined(props.prelabel)) return props.prelabel;
    else if (!check.isUndefined(props.label)) return props.label;
    return "";
  });
  const post_label = computed(() => {
    if (!check.isUndefined(props.postlabel)) return props.postlabel;
    else if (!check.isUndefined(props.label)) return props.label;
    return "";
  });
  const fieldLabel = computed(() => propCheck("label", false));
  const prelabelDisplay = computed(() => propCheck("prelabel", false));
  const postlabelDisplay = computed(() => propCheck("postlabel", false));

  // Behavior
  const canClear = computed(() => propCheck("clear", true));
</script>
